import { confirmationConstants } from "../../../constants/confirmation/confirmation.constants";

export function confirmation(state = {}, action) {
  switch (action.type) {
    case confirmationConstants.UPDATE_CONFIRMATION_REQUEST:
      return { ...state, loading: true,  };
    case confirmationConstants.UPDATE_CONFIRMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        confirmation: action.confirmation
      };
    case confirmationConstants.UPDATE_CONFIRMATION_FAILURE:
      return { ...state, loading: false, error: action.error };

    case confirmationConstants.GET_CONFIRMATION_LIST_REQUEST:
      return { ...state, loading: true, };
    case confirmationConstants.GET_CONFIRMATION_LIST_SUCCESS:
      return { ...state, loading: false, confirmationList: action.confirmationList, confirmationListTime:Date.now() };
    case confirmationConstants.GET_CONFIRMATION_LIST_FAILURE:
      return { ...state, loading: false, error: action.error };

      case confirmationConstants.CREATE_CONFIRMATION_RANGE_REQUEST:
        return { ...state, loading: true, };
      case confirmationConstants.CREATE_CONFIRMATION_RANGE_SUCCESS:
        return { ...state, loading: false, confirmationList: action.confirmations, confirmationListTime:Date.now() };
      case confirmationConstants.CREATE_CONFIRMATION_RANGE_FAILURE:
        return { ...state, loading: false, error: action.error };

    case confirmationConstants.GET_CONFIRMATION_REQUEST:
      return { ...state, loading: true, };
    case confirmationConstants.GET_CONFIRMATION_SUCCESS:
      return { ...state, loading: false, confirmation: action.confirmation };
    case confirmationConstants.GET_CONFIRMATION_FAILURE:
      return { ...state, loading: false, error: action.error };
    case confirmationConstants.CREATE_CONFIRMATION_REQUEST:
      return { ...state, loading: true, };
    case confirmationConstants.CREATE_CONFIRMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        confirmation: action.confirmation
      };
    case confirmationConstants.CREATE_CONFIRMATION_FAILURE:
      return { ...state, loading: false, error: action.error };

    case confirmationConstants.DELETE_CONFIRMATION_REQUEST:
      return { ...state, loading: true, };
    case confirmationConstants.DELETE_CONFIRMATION_SUCCESS:
      return { ...state, loading: false, saved: true };
    case confirmationConstants.DELETE_CONFIRMATION_FAILURE:
      return { ...state, loading: false, error: action.error };
      
    default:
      return state;
  }
}
